// Re-read the contiguous window from the head through its previous oldest
// cursor. Replacing a fixed number of pages would lose old rows when new ones
// push them across page boundaries. Never retain unverified old payloads.
export async function readActivityWindow(readPage, { oldest = null, more = false, start = null, signal, maxPages = 10 } = {}) {
  const events = new Map();
  const cursors = new Set();
  let before = start;
  if (start !== null) cursors.add(start);
  let reached = oldest === null;
  let extra = more;
  for (let pageNo = 0; pageNo < maxPages; pageNo++) {
    signal?.throwIfAborted();
    const page = await readPage(before);
    signal?.throwIfAborted();
    for (const event of page.events ?? []) events.set(event.eventId, event);
    const tail = page.events?.at(-1)?.cursor ?? page.nextBeforeCursor;
    const previouslyReached = reached;
    if (oldest !== null && tail != null && BigInt(tail) <= BigInt(oldest)) reached = true;
    if (!page.hasMore || (reached && (!extra || previouslyReached))) {
      return { ...page, events: [...events.values()], oldest: tail ?? oldest,
        incomplete: Boolean(page.hasMore && pageNo + 1 === maxPages) };
    }
    if (reached) extra = false;
    before = page.nextBeforeCursor;
    if (!before || cursors.has(before)) throw new Error('이전 기록을 다시 확인해 주세요.');
    cursors.add(before);
    if (pageNo + 1 === maxPages) return { ...page, events: [...events.values()], oldest: tail ?? oldest, incomplete: true };
  }
}
